import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './neighbors.json';

const Neighbors = () => {
  return (
    <div className="topic-page-container">
        <TopicsPageLayout
            
            description="Community relations, neighborhood vocabulary, and social English. B2 level grammar, vocabulary, and discussion exercises."
            level="B2"
            title="Neighbors"
            image="/Images/neighbors1.webp"
            seoTitle="Free English Lesson Plans: Neighbours"
            seoDescription="Community relations, neighborhood vocabulary, and social English. B2 level grammar, vocabulary, and discussion exercises."
        >
            {topicData.map((section, index) => (
                <div key={index} className="lesson-section-wrapper">
                    <TopicsRouter sectionData={section} />
                </div>
            ))}
        </TopicsPageLayout>
    </div>
  );
};

export default Neighbors;


